module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__cov-progress",
    style: (_vm.style)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d472fe3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-progressbar/vue-progressbar.vue
// module id = 222
// module chunks = 1